import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React from 'react';
import useProvider from '../../core/EcrionProvider/useProvider';
import AI from '../AI';
import AISidebarBridge from '../AI/Bridge';
import useExtensions from './useExtensions';
import crossDocumentProtocol from './crossDocumentProtocol';

var useIframeProvider = function useIframeProvider() {
  var eProps = useProvider();
  var microservice = eProps.microservice,
      extensions = eProps.extensions;
  var usesIframeProvider = extensions && typeof extensions === 'object' && extensions.forwardApp;

  var _React$useState = React.useState(usesIframeProvider ? {
    microservice: undefined,
    extensions: false
  } : {
    microservice: microservice,
    extensions: extensions
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      providerProps = _React$useState2[0],
      setProviderProps = _React$useState2[1];

  React.useEffect(function () {
    if (usesIframeProvider) {
      //is a nested iframe, get hosted app props
      crossDocumentProtocol.on(window, 'GetProviderPropsResponse', function (data) {
        setProviderProps({
          microservice: data.microservice,
          extensions: data.extensions
        });
      });
      crossDocumentProtocol.send(window.parent, 'GetProviderProps');
      return function () {
        crossDocumentProtocol.off(window, 'GetProviderPropsResponse');
      };
    } else {//is app, handled by IframeHost
    }
  }, [usesIframeProvider, eProps, setProviderProps]);
  return providerProps;
};
/**
 * @param {import('./types').ExtensionsProps} props
 */


var Extensions = function Extensions(_ref) {
  var extensionFor = _ref.extensionFor,
      workspace = _ref.workspace,
      path = _ref.path,
      id = _ref.id,
      rest = _objectWithoutProperties(_ref, ["extensionFor", "workspace", "path", "id"]);

  var installedExtensions = useExtensions(extensionFor);

  var _useIframeProvider = useIframeProvider(),
      microservice = _useIframeProvider.microservice,
      extensions = _useIframeProvider.extensions;

  var isApp = microservice && microservice.id;
  if (!(extensions || isApp)) return null;
  return React.createElement(React.Fragment, null, installedExtensions.map(function (installedExt, idx) {
    if (isAppExtensionDisabled(installedExt.app, extensions)) return null;

    if (installedExt.app === 'com.ecrion.ai') {
      if (installedExt.type === 'Sidebar') {
        var aiProps = AISidebarBridge.getProps(extensionFor, workspace, path, id);
        var overrides = getExtensionSettings(installedExt.app, extensions);
        return React.createElement(AI, Object.assign({
          key: idx
        }, overrides, rest, aiProps));
      }
    }

    return null;
  }));
};

var isAppExtensionDisabled = function isAppExtensionDisabled(appId, extensions) {
  if (typeof extensions === 'boolean') return !extensions;
  if (!extensions) return false;
  return isExtensionDisabled(extensions[appId]);
};
/**
 * @param {import('../../core/EcrionProvider/types').ExtensionsSettingProps} appExtension
 */


var isExtensionDisabled = function isExtensionDisabled(appExtension) {
  if (typeof appExtension === 'undefined') return false;
  if (appExtension === 'auto') return false;
  if (typeof appExtension === 'boolean') return !appExtension;
  return isExtensionDisabled(appExtension.enabled);
};

var getExtensionSettings = function getExtensionSettings(appId, extensions) {
  if (!extensions) return {};
  if (typeof extensions === 'boolean') return {};
  var appExtension = extensions[appId];
  if (typeof appExtension !== 'object') return {};

  var enabled = appExtension.enabled,
      overrides = _objectWithoutProperties(appExtension, ["enabled"]);

  return overrides;
};

export default Extensions;